import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot } from 'lexical';

import {
    clearCommentDraft,
    getCommentDraftBySlideId,
    saveCommentDraft,
} from 'js/src/data/comments';
import { useAppDispatch } from 'js/src/libs/RootState';

type Props = {
    slideId: string;
};

const CommentDraftPlugin: React.FC<Props> = React.memo(function CommentDraftPlugin({ slideId }) {
    const [editor] = useLexicalComposerContext();
    const dispatch = useAppDispatch();
    const draft = useSelector(getCommentDraftBySlideId(slideId));

    useEffect(() => {
        if (draft) {
            try {
                const editorState = editor.parseEditorState(draft);
                editor.setEditorState(editorState);
            } catch {
                dispatch(clearCommentDraft({ slide_id: slideId }));
            }
        }
        // Only run on mount — draft is intentionally excluded from deps
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        return () => {
            const editorState = editor.getEditorState();
            const textContent = editorState.read(() => $getRoot().getTextContent());
            if (textContent.trim()) {
                dispatch(saveCommentDraft({ slide_id: slideId, draft: editorState.toJSON() }));
            }
        };
    }, [editor, dispatch, slideId]);

    return null;
});

export default CommentDraftPlugin;
